import { cn } from './lib/utils.js';

export type DimeFilterCountBadgeProps = Readonly<{
  count: number;
  className?: string;
}>;

/** The applied-filter count on a Filter button. Renders nothing at zero.
 *  Always aria-hidden: the button's own accessible name carries the count. */
export function DimeFilterCountBadge({ count, className }: DimeFilterCountBadgeProps) {
  if (count <= 0) return null;

  return (
    <span
      aria-hidden
      className={cn(
        'inline-flex size-4 items-center justify-center rounded-full bg-primary text-[0.625rem] font-medium text-primary-foreground',
        className,
      )}
    >
      {count}
    </span>
  );
}
